
<language-voice-view *ngIf="!editView && languageVoice?.id" [languageVoice]="languageVoice" (clickEdit)="switchView()"></language-voice-view>
<div class="flex" *ngIf="editView">
  <button class="btn-xs mr-2" (click)="save()">Save</button>
  <audio-recorder (afterSave)="afterSaveAudioFile($event)" [disableVoiceToText]="true" btnClass="btn-xs"></audio-recorder>
</div>
